// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.media-module-container {
    width: 100%;
}

.media-module-container .media-files {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 4px;
}

.media-module-container .media-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: grey;
    transition: ease-in-out 0.3s;
    overflow: hidden;
}

.media-module-container .media-wrapper:hover {
    scale: 1.01;
}

.media-module-container .media-wrapper .gallery-media {
    height: 220px;
    width: auto;
    max-width: 100%;
}

/* Modal content */
.gallery-preview-modal .modal-content {
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    align-items: center;
    background-color: white;
    margin: 40px;
    height: calc(100vh - 80px);
    width: calc(100vw - 80px);
    padding: 40px;
    border-radius: 42px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    overflow: auto;
}

@media (max-width: 768px) {
    .gallery-preview-modal .modal-content {
        padding: 10px;
    }
}

.gallery-preview-modal .modal-content--left-column,
.gallery-preview-modal .modal-content--right-column {
    display: flex;
    justify-content: center;
    width: 50%;
    padding: 20px;
    height: fit-content;
}

.gallery-preview-modal .modal-content--left-column {
    flex-direction: column;
}

.gallery-preview-modal .modal-content--right-column {
    flex-direction: row;
    gap: 10px;
}

@media (max-width: 768px) {
    .gallery-preview-modal .modal-content--right-column {
        flex-direction: column;
    }
}

@media (max-width: 768px) {
    .gallery-preview-modal .modal-content--left-column,
    .gallery-preview-modal .modal-content--right-column {
        width: 100%;
    }
}

.gallery-preview-modal .modal-preview-media {
    width: 100%;
    height: auto;
    border-radius: 20px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.gallery-preview-modal .close-button, .share-button {
    border: none;
    padding: 10px;
    border-radius: 4px;
    margin-bottom: 10px;
    cursor: pointer;
    color: #fff;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.3s ease;
    width: 50%;
}

@media (max-width: 768px) {
    .gallery-preview-modal .close-button, .share-button {
        width: 100%;
    }
}

.gallery-preview-modal .close-button svg, .share-button svg {
    margin-right: 8px;
}

.gallery-preview-modal .close-button {
    background-color: #FF6F61;
}

.gallery-preview-modal .close-button:hover {
    background-color: #d32f2f;
}

.gallery-preview-modal .share-button {
    background-color: #2196F3;
}

.gallery-preview-modal .share-button:hover {
    background-color: #1976D2;
}

/* Style pour la gestion des erreurs */
.media-module-container .error-message {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 10px;
    background-color: #f8d7da;
    color: red;
    font-size: 1.5rem;
}

.media-module-container .error-message p {
    margin: 0;
    text-align: center;
}

.media-module-container .error-message .error-label {
    font-weight: bold;
}

.media-module-container .error-message .error-details {
    font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/modules/cameraModule/assets/style.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,WAAW;IACX,eAAe;AACnB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,0BAA0B;IAC1B,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;;IAEI,aAAa;IACb,uBAAuB;IACvB,UAAU;IACV,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;;QAEI,WAAW;IACf;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sCAAsC;IACtC,UAAU;AACd;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,sCAAsC;AACtC;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".media-module-container {\n    width: 100%;\n}\n\n.media-module-container .media-files {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 4px;\n}\n\n.media-module-container .media-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background-color: grey;\n    transition: ease-in-out 0.3s;\n    overflow: hidden;\n}\n\n.media-module-container .media-wrapper:hover {\n    scale: 1.01;\n}\n\n.media-module-container .media-wrapper .gallery-media {\n    height: 220px;\n    width: auto;\n    max-width: 100%;\n}\n\n/* Modal content */\n.gallery-preview-modal .modal-content {\n    display: flex;\n    flex-wrap: wrap;\n    align-content: center;\n    align-items: center;\n    background-color: white;\n    margin: 40px;\n    height: calc(100vh - 80px);\n    width: calc(100vw - 80px);\n    padding: 40px;\n    border-radius: 42px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);\n    overflow: auto;\n}\n\n@media (max-width: 768px) {\n    .gallery-preview-modal .modal-content {\n        padding: 10px;\n    }\n}\n\n.gallery-preview-modal .modal-content--left-column,\n.gallery-preview-modal .modal-content--right-column {\n    display: flex;\n    justify-content: center;\n    width: 50%;\n    padding: 20px;\n    height: fit-content;\n}\n\n.gallery-preview-modal .modal-content--left-column {\n    flex-direction: column;\n}\n\n.gallery-preview-modal .modal-content--right-column {\n    flex-direction: row;\n    gap: 10px;\n}\n\n@media (max-width: 768px) {\n    .gallery-preview-modal .modal-content--right-column {\n        flex-direction: column;\n    }\n}\n\n@media (max-width: 768px) {\n    .gallery-preview-modal .modal-content--left-column,\n    .gallery-preview-modal .modal-content--right-column {\n        width: 100%;\n    }\n}\n\n.gallery-preview-modal .modal-preview-media {\n    width: 100%;\n    height: auto;\n    border-radius: 20px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);\n}\n\n.gallery-preview-modal .close-button, .share-button {\n    border: none;\n    padding: 10px;\n    border-radius: 4px;\n    margin-bottom: 10px;\n    cursor: pointer;\n    color: #fff;\n    font-size: 18px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background-color 0.3s ease;\n    width: 50%;\n}\n\n@media (max-width: 768px) {\n    .gallery-preview-modal .close-button, .share-button {\n        width: 100%;\n    }\n}\n\n.gallery-preview-modal .close-button svg, .share-button svg {\n    margin-right: 8px;\n}\n\n.gallery-preview-modal .close-button {\n    background-color: #FF6F61;\n}\n\n.gallery-preview-modal .close-button:hover {\n    background-color: #d32f2f;\n}\n\n.gallery-preview-modal .share-button {\n    background-color: #2196F3;\n}\n\n.gallery-preview-modal .share-button:hover {\n    background-color: #1976D2;\n}\n\n/* Style pour la gestion des erreurs */\n.media-module-container .error-message {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    padding: 10px;\n    background-color: #f8d7da;\n    color: red;\n    font-size: 1.5rem;\n}\n\n.media-module-container .error-message p {\n    margin: 0;\n    text-align: center;\n}\n\n.media-module-container .error-message .error-label {\n    font-weight: bold;\n}\n\n.media-module-container .error-message .error-details {\n    font-style: italic;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
